import { render } from "./status_popover.vue?vue&type=template&id=fa4a5d94"
import script from "./status_popover.js?vue&type=script&lang=js"
export * from "./status_popover.js?vue&type=script&lang=js"

import "./status_popover.vue?vue&type=style&index=0&id=fa4a5d94&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__